import { render, staticRenderFns } from "./ui-radio.vue?vue&type=template&id=88abba8a&scoped=true"
import script from "./ui-radio.vue?vue&type=script&lang=js"
export * from "./ui-radio.vue?vue&type=script&lang=js"
import style0 from "./ui-radio.vue?vue&type=style&index=0&id=88abba8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88abba8a",
  null
  
)

export default component.exports